import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';

import { MasterTab } from '../MasterTab';
import { deleteDataWithParameters, getAllDetails, getAllDetailsDirect, postAllData } from '../../../service/ProductService';
import { APP_STATES, BOARDS, UPDATE_BOARDS } from '../../../config/ApiConstant';
import { SkeletonbodyTemplate, Skeletonitems, defaultPageRowOptions, defaultRowOptions, paginatorLinks, showingEntries } from '../../../appconfig/Settings';
import { BoardMasterListColumns } from '../../../appconfig/DatatableSetting';
import { Dialog } from 'primereact/dialog';
import { AddUpdateBillMasterValidate } from '../../../config/Validate';
import { Dropdown } from 'primereact/dropdown';

export const BoardMaster = () => {
    document.title = 'Board Master | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [applications, setApplications] = useState<any>([]);
    const [name, setName] = useState<any>('');
    const [addSelectedStateId, setAddSelectStateId] = useState<any>(null);

    const [selectedStateId, setSelectStateId] = useState<any>(null);
    const [addUpdateLoader, setAddUpdateLoader] = useState<boolean>(false);
    const [addUpdateModal, setAddUpdateModal] = useState<boolean>(false);
    const [editId, setEditId] = useState<any>(null);
    const [errors, setErrors] = useState<any>({});
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [deleteId, setDeleteId] = useState<any>(null);
    const [deleteLoader, setDeleteLoader] = useState<boolean>(false);

    //state
    const [statesList, setStatesList] = useState<any>([]);

    // useEffect
    useEffect(() => {
        getStates();
        getBoardMasterList();
    }, []);

    // useEffect
    useEffect(() => {
        getBoardMasterList();
    }, [selectedStateId]);

    // Get States
    const getStates = async () => {
        try {
            const response = await getAllDetailsDirect(APP_STATES);
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setStatesList([]);
                } else {
                    let stateData = [];
                    for (let i = 0; i < DataList.length; i++) {
                        const stateObj: any = {};
                        stateObj['name'] = DataList[i].name;
                        stateObj['code'] = DataList[i].id;
                        stateData.push(stateObj);
                    }
                    setStatesList(stateData);
                }
            } else {
                setStatesList([]);
            }
        } catch (error: any) {
            setStatesList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    const rightToolbarTemplate = () => {
        return (
            <>
                <Button label="Add Board Master" icon="pi pi-plus" className="p-button" onClick={() => openAddModal()} />
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined ml-3"></Button>
            </>
        );
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
                <div className="input-effect-div ml-3">
                    <Dropdown value={selectedStateId} name="boardState" options={statesList} filter optionLabel="name" placeholder="Select State" onChange={(e) => setSelectStateId(e.value)} className={errors['boardState'] && 'p-invalid'} />
                </div>
            </>
        );
    };

    // Get applications list
    const getBoardMasterList = async () => {
        try {
            setPageLoad(false);
            let state = !window.cn(selectedStateId?.name) ? selectedStateId?.name : ""
            const response = await getAllDetailsDirect(BOARDS + '?StateName=' +  state );

            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setApplications([]);
                } else {
                    setApplications(DataList);
                }
                setPageLoad(true);
            } else {
                setPageLoad(true);
                setApplications([]);
            }
        } catch (error: any) {
            setPageLoad(true);
            setApplications([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Open add modal
    const openAddModal = () => {
        setAddUpdateModal(true);
    };

    // Close add modal
    const closeAddUpdateModal = () => {
        setName('');
        setAddSelectStateId(null);
        setEditId(null);
        setAddUpdateLoader(false);
        setAddUpdateModal(false);
        setErrors({});
    };

    // Open edit modal
    const openEditModal = (rowData: any) => {
        let stateObj = {
            name : rowData?.StateNm,
            code : rowData?.StateSrNo,

        }
        setName(rowData.BoardNm);
        setAddSelectStateId(stateObj);
        setEditId(rowData.SrNo);
        setAddUpdateModal(true);
    };

    // Open delete modal
    const openDeleteModal = (index: any) => {
        setDeleteId(index);
        setDeleteModal(true);
    };

    // Close delete modal
    const closeDeleteModal = () => {
        setDeleteId(null);
        setDeleteModal(false);
    };

    // Template for action
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <div className="flex">
                    <Button icon="pi pi-pencil" tooltip="Edit" tooltipOptions={{ position: 'top' }} className="p-button-rounded" onClick={() => openEditModal(rowData)} />
                    <Button icon="pi pi-trash" tooltip="Delete" tooltipOptions={{ position: 'top' }} className="p-button-danger p-button-rounded ml-2" onClick={() => openDeleteModal(rowData.SrNo)} />
                </div>
            </>
        );
    };

    // On submit add update app
    const onSubmitAddUpdateApp = async () => {
        try {
            const { errors, isError } = AddUpdateBillMasterValidate(name, addSelectedStateId);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setAddUpdateLoader(true);

                //URL
                let apiUrl = BOARDS;

                //Request object
                const requestData: any = {
                    BoardNm: name,
                    StateNm: addSelectedStateId?.name,
                    StateSrNo: addSelectedStateId?.code
                };

                if (!window.cn(editId)) {
                    requestData['SrNo'] = editId;
                    apiUrl = UPDATE_BOARDS;
                }

                //apicall
                const response = await postAllData(apiUrl, requestData);
                if (response && !window.cn(response)) {
                    setName('');
                    setEditId(null);
                    setAddSelectStateId(null);
                    setAddUpdateLoader(false);
                    toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });
                    setTimeout(() => {
                        setAddUpdateModal(false);
                        getBoardMasterList();
                    }, 1000);
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast

                setAddUpdateLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // Delete application
    const deleteApplication = async () => {
        try {
            setDeleteLoader(true);
            // Delete api call
            const response = await deleteDataWithParameters(BOARDS + '?SrNo=' + deleteId);
            if (response) {
                setDeleteLoader(false);
                setDeleteModal(false);
                setDeleteId(null);
                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: response?.data
                });
                setTimeout(() => {
                    getBoardMasterList();
                }, 1500);
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Something went wrong, Please try again.'
                });
                setDeleteLoader(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setDeleteLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    return (
        <>
            <MasterTab mainTabLabel="Board Master" />
            <Toast ref={toast} />
            <div className="grid crud-demo mt-3">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={applications}
                                    showGridlines
                                    stripedRows
                                    className="datatable-responsive"
                                    emptyMessage="No Data Found"
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={applications.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                    removableSort
                                >
                                    {BoardMasterListColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {BoardMasterListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Add Update Dialog */}
            <Dialog
                visible={addUpdateModal}
                className="p-fluid"
                style={{ width: '450px' }}
                header={editId !== null ? 'Edit Board Master' : 'Add Board Master'}
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeAddUpdateModal} />
                        <Button label="Submit" icon="pi pi-check" className="p-button-primary" onClick={() => onSubmitAddUpdateApp()} loading={addUpdateLoader} />
                    </>
                }
                onHide={closeAddUpdateModal}
            >
                <div className="formgrid grid">
                    <div className="field col-12">
                        <label htmlFor="boardName">
                            Board Name <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <InputText value={name} name="boardName" autoComplete="off" placeholder="Enter Board Name" onChange={(e) => setName(e.target.value)} className={errors['name'] && 'p-invalid'} />
                            <span className="focus-bg"></span>
                        </div>

                        <small className="p-invalid-txt">{errors['name']}</small>
                    </div>
                    <div className="field col-12 md:col-12">
                        <label htmlFor="boardState">State</label>
                        <div className="input-effect-div">
                            <Dropdown value={addSelectedStateId} name="boardState" options={statesList} filter optionLabel="name" placeholder="Select State" onChange={(e) => setAddSelectStateId(e.value)} className={errors['state'] && 'p-invalid'} />
                        </div>
                        <span className="focus-bg"></span>
                        <small className="p-invalid-txt">{errors['state']}</small>
                    </div>
                </div>
            </Dialog>

            {/* Delete Dialog */}
            <Dialog
                visible={deleteModal}
                style={{ width: '450px' }}
                header="Delete Board Master"
                modal
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeDeleteModal} />
                        <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={deleteApplication} loading={deleteLoader} />
                    </>
                }
                onHide={closeDeleteModal}
            >
                <div className="flex align-items-center justify-content-start">
                    <i className="pi pi-exclamation-triangle mr-3 delete-triangle" style={{ fontSize: '2rem' }} />
                    <span className="delete-dialog-note">Note: Once you delete this Board Master, This will be deleted permentatly.</span>
                </div>
            </Dialog>
        </>
    );
};
